/**
 * One data set, two layouts: a real <table> on desktop and stacked rows (a title + label/value pairs) on a phone. Both are in the
 * DOM and CSS shows one (`display: none` also hides the other from assistive tech), so no JS media queries are involved.
 */
import type { ReactNode } from "react";

export type Column<R> = { key: string; label: string; render: (row: R) => ReactNode; num?: boolean };

export function ResponsiveTable<R>({ label, columns, rows, rowKey, className = "" }: { label: string; columns: Column<R>[]; rows: R[]; rowKey: (row: R) => string; className?: string }) {
  const [primary, ...rest] = columns;
  if (!primary) return null;
  return (
    <div className={`rt ${className}`}>
      <div className="table-wrap rt-wide">
        <table className="data-table" aria-label={label}>
          <thead><tr>{columns.map((c) => <th key={c.key} scope="col" className={c.num ? "num" : undefined}>{c.label}</th>)}</tr></thead>
          <tbody>
            {rows.map((r) => (
              <tr key={rowKey(r)}>{columns.map((c, i) => i === 0
                ? <th key={c.key} scope="row" className="rt-title">{c.render(r)}</th>
                : <td key={c.key} className={c.num ? "num" : undefined}>{c.render(r)}</td>)}</tr>
            ))}
          </tbody>
        </table>
      </div>
      <ul className="rt-narrow" aria-label={label}>
        {rows.map((r) => (
          <li key={rowKey(r)} className="rt-row">
            <div className="rt-primary">{primary.render(r)}</div>
            <dl className="rt-fields">
              {rest.map((c) => <div key={c.key}><dt>{c.label}</dt><dd>{c.render(r)}</dd></div>)}
            </dl>
          </li>
        ))}
      </ul>
    </div>
  );
}
